import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  dataEditAdditionalTimeSheet: {},
  dataApprovalAdditionalTimeSheet: {},
  dataListApprovalAdditionalTimeSheet: {},
  isAdmin: false,
  dataCommonAdditionalTimeSheet: {
    admin: [],
    manager: [],
    timeSheet: {}
  },
  additionalTimeSheets: [],
  additionalTimeSheet: {},
  totalTimeSheetRequest: {},
};

// getters
export const getters = {
  isAdmin: state => state.isAdmin,
  dataCommonAdditionalTimeSheet: state => state.dataCommonAdditionalTimeSheet,
  dataEditAdditionalTimeSheet: state => state.dataEditAdditionalTimeSheet,
  dataApprovalAdditionalTimeSheet: state =>
    state.dataApprovalAdditionalTimeSheet,
  dataListApprovalAdditionalTimeSheet: state =>
    state.dataListApprovalAdditionalTimeSheet,
  additionalTimeSheets: state => state.additionalTimeSheets,
  additionalTimeSheet: state => state.additionalTimeSheet,
  pagination: state => state.pagination,
  totalTimeSheetRequest: state => state.totalTimeSheetRequest,
};

// mutations
export const mutations = {
  [types.ADDITIONAL_TIMESHEET.IS_ADMIN](
    state,
    additionalTimeSheet
  ) {
    state.isAdmin = additionalTimeSheet.isAdmin;
  },
  [types.ADDITIONAL_TIMESHEET.CREATE_ADDITIONAL_TIMESHEET](
    state,
    additionalTimeSheet
  ) {
    state.dataCommonAdditionalTimeSheet = additionalTimeSheet;
  },

  [types.ADDITIONAL_TIMESHEET.EDIT_ADDITIONAL_TIMESHEET](
    state,
    additionalTimeSheet
  ) {
    state.dataEditAdditionalTimeSheet = additionalTimeSheet;
  },

  [types.ADDITIONAL_TIMESHEET.APPROVAL_ADDITIONAL_TIMESHEET](
    state,
    additionalTimeSheet
  ) {
    state.dataApprovalAdditionalTimeSheet = additionalTimeSheet;
  },

  [types.ADDITIONAL_TIMESHEET.LIST_APPROVAL_ADDITIONAL_TIMESHEET](
    state,
    data
  ) {
    state.dataListApprovalAdditionalTimeSheet = data.timeSheetRequests;
    state.pagination.from = data.timeSheetRequests.from;
    state.pagination.to = data.timeSheetRequests.to;
    state.pagination.totalPage = data.timeSheetRequests.last_page;
    state.pagination.path = data.timeSheetRequests.path;
    state.pagination.currentPage = data.timeSheetRequests.current_page;
    state.pagination.totalRecord = data.timeSheetRequests.total;
    state.pagination.perPage = data.timeSheetRequests.per_page;
    state.totalTimeSheetRequest = data.totalTimeSheetRequest;
  },

  [types.ADDITIONAL_TIMESHEET.FETCH_ADDITIONAL_TIMESHEET](
    state,
    data
  ) {
    state.additionalTimeSheets = data.timesheetRequests;
    state.pagination.from = data.timesheetRequests.from;
    state.pagination.to = data.timesheetRequests.to;
    state.pagination.totalPage = data.timesheetRequests.last_page;
    state.pagination.path = data.timesheetRequests.path;
    state.pagination.currentPage = data.timesheetRequests.current_page;
    state.pagination.totalRecord = data.timesheetRequests.total;
    state.pagination.perPage = data.timesheetRequests.per_page;
    state.totalTimeSheetRequest = data.totalTimeSheetRequest;
  },

  [types.ADDITIONAL_TIMESHEET.SHOW_ADDITIONAL_TIMESHEET](
    state,
    additionalTimeSheet
  ) {
    state.additionalTimeSheet = additionalTimeSheet;
  }
};

// actions
export const actions = {
  async commonAdditionalTimeSheet({ commit }, payload) {
    const response = await axios.get(api.CREATE_ADDITIONAL_TIMESHEET, {
      params: payload
    });
    commit(
      types.ADDITIONAL_TIMESHEET.CREATE_ADDITIONAL_TIMESHEET,
      response.data
    );
  },

  async editAdditionalTimeSheet({ commit }, params) {
    let url = `${api.EDIT_ADDITIONAL_TIMESHEET}/${params}/edit`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(
        types.ADDITIONAL_TIMESHEET.EDIT_ADDITIONAL_TIMESHEET,
        response.data
      );
    }
  },

  async showApprovalAdditionalTimeSheet({ commit }, params) {
    let url = `${api.SHOW_APPROVAL_ADDITIONAL_TIMESHEET}/${params}`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(
        types.ADDITIONAL_TIMESHEET.APPROVAL_ADDITIONAL_TIMESHEET,
        response.data
      );
    }
  },

  // eslint-disable-next-line
  async registerAdditionalTimeSheet({ commit }, params) {
    await axios.post(api.REGISTER_ADDITIONAL_TIMESHEET, params);
  },

  // eslint-disable-next-line
  async updateAdditionalTimeSheet({ commit }, params) {
    let url = `${api.UPDATE_ADDITIONAL_TIMESHEET}/${params.get("id")}`;
    await axios.post(url, params);
  },

  // eslint-disable-next-line
  async approvalAdditionalTimeSheet({ commit }, params) {
    let url = `${api.APPROVAL_ADDITIONAL_TIMESHEET}/${params.id}`;
    await axios.post(url, params.data);
  },

  async listAdditionalTimeSheetApproval({ commit }, payload) {
    const response = await axios.get(api.APPROVAL_ADDITIONAL_TIMESHEET, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        employee_info: payload.employee_info,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        start_date: payload.start_date,
        end_date: payload.end_date,
        status: payload.status,
        status_timesheet_request: payload.status_timesheet_request,
        approveStatus: payload.approveStatus,
        sort_column: payload.sortColumn,
        sort_by: payload.sortBy,
        month: payload.month
      }
    });
    commit(
      types.ADDITIONAL_TIMESHEET.LIST_APPROVAL_ADDITIONAL_TIMESHEET,
      response.data
    );
    commit(
      types.ADDITIONAL_TIMESHEET.IS_ADMIN,
      response.data
    );
  },

  async fetchAdditionalTimeSheet({ commit }, payload) {
    const response = await axios.get(api.LIST_ADDITIONAL_TIMESHEET, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        sort_column: payload.sortColumn,
        sort_by: payload.sortBy,
        status: payload.status,
        month: payload.month
      }
    });
    commit(
      types.ADDITIONAL_TIMESHEET.FETCH_ADDITIONAL_TIMESHEET,
      response.data
    );
  },

  // eslint-disable-next-line
  async deleteAdditionalTimeSheet({ commit }, overTimeRequestId) {
    await axios.delete(
      api.DELETE_ADDITIONAL_TIMESHEET + "/" + overTimeRequestId
    );
  },

  async detailOverTimeRequest({ commit }, additionalTimeSheetId) {
    const response = await axios.get(
      api.SHOW_ADDITIONAL_TIMESHEET + "/" + additionalTimeSheetId
    );
    commit(types.ADDITIONAL_TIMESHEET.SHOW_ADDITIONAL_TIMESHEET, response.data);
  },
  async approvalListAdditionalTimeSheet(_, params) {
    let url = `${api.APPROVE_LIST_ADDITIONAL_TIMESHEET}`;
    await axios.post(url, params);
  }
};
